import React, { createContext, useCallback, useRef, useContext } from 'react'

const Ctx = createContext(null)
export const useCsrf = () => useContext(Ctx)

export function CsrfProvider({ children }) {
  const token = useRef('')
  const exp   = useRef(0)
  const pending = useRef(null)

  const load = async () => {
    const res = await fetch('/api/csrf-token', { credentials: 'include' })
    const { token: t } = await res.json()
    token.current = t
    exp.current = Date.now() + 50 * 60 * 1000
    pending.current = null
    return t
  }

  const ensure = useCallback(async (force = false) => {
    if (!force && token.current && Date.now() < exp.current) return token.current
    if (force) { token.current = ''; exp.current = 0 }
    if (!pending.current) pending.current = load()
    return pending.current
  }, [])

  const reset = useCallback(() => { token.current = ''; exp.current = 0 }, [])

  const contextValue = React.useMemo(() => ({ ensure, reset }), [ensure, reset])

  return <Ctx.Provider value={contextValue}>{children}</Ctx.Provider>
}
